import React from "react";
import { SEO, PageLayout, Image } from "@bluefin/components";
import { Grid } from "semantic-ui-react";
import { graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import { getComponentFiles } from "../utils/utils";

export default class MenuPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const { fishermanBusiness, fishermanBusinessWebsitePage } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
        />
        <PageLayout hero={null}>
          <Image
            src={getComponentFiles({
              components: fishermanBusinessWebsitePage.components,
              componentName: "HeroElement",
              componentIdentifier: "background",
              numToSelect: 1,
            })}
            className={"page-background-image"}
            background={true}
          >
            <div />
          </Image>
          <Grid
            stackable={true}
            verticalAlign={"middle"}
            textAlign={"left"}
            centered={true}
            column={2}
            className={"menu-images-container"}
          >
            <Grid.Row stretched={true}>
              <Grid.Column textAlign={"center"} width={8}>
                <a
                  href={
                    "https://fisherman.gumlet.io/public/a841cb1d-6475-436a-b081-df4add91369f/ACL-SpiritsBook7-WEB-min.pdf"
                  }
                  target={"_blank"}
                >
                  <Image
                    size={"big"}
                    centered={true}
                    src={
                      "https://fisherman.gumlet.io/public/a841cb1d-6475-436a-b081-df4add91369f/Spirits.png"
                    }
                  />
                </a>
                <h3>
                  <a
                    href={
                      "https://fisherman.gumlet.io/public/a841cb1d-6475-436a-b081-df4add91369f/ACL-SpiritsBook7-WEB-min.pdf"
                    }
                    target={"_blank"}
                  >
                    Spirits
                  </a>
                </h3>
              </Grid.Column>
              <Grid.Column textAlign={"center"} width={8}>
                <a
                  href={
                    "https://fisherman.gumlet.io/public/a841cb1d-6475-436a-b081-df4add91369f/ACL_Rag_No.13_FinalPrint-compressed.pdf"
                  }
                  target={"_blank"}
                >
                  <Image
                    size={"big"}
                    centered={true}
                    src={
                      "https://fisherman.gumlet.io/public/a841cb1d-6475-436a-b081-df4add91369f/Menu.png"
                    }
                  />
                </a>
                <h3>
                  <a
                    href={
                      "https://fisherman.gumlet.io/public/a841cb1d-6475-436a-b081-df4add91369f/ACL_Rag_No.13_FinalPrint-compressed.pdf"
                    }
                    target={"_blank"}
                  >
                    Menu - Alley Cat Rag #13
                  </a>
                </h3>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </PageLayout>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(pageType: { eq: "Menu" }) {
      title
      components {
        fastId
        componentIdentifier
        order
        files {
          file
          altText
          gatsbyFile {
            childImageSharp {
              gatsbyImageData(layout: FULL_WIDTH)
            }
          }
        }
      }
    }
  }
`;
